<h1 mat-dialog-title>Zusätzlichen Kommentar bearbeiten</h1>
<!-- <div mat-dialog-content>{{ description }}</div> -->

<mat-form-field class="text-area">
  <mat-label>Zusätzlicher Kommentar</mat-label>
  <textarea rows="7" matInput [(ngModel)]="reportItem.customNote"></textarea>
  <!-- @if (reportItem.customNote) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="reportItem.customNote = ''">
      <mat-icon>close</mat-icon>
    </button>
  } -->
</mat-form-field>

<div mat-dialog-actions>
  <button mat-button cdkFocusInitial mat-dialog-close (click)="revertInput()">Abbrechen</button>
  <button mat-button [mat-dialog-close]="'speichern'">Speichern</button>
</div>
